import React from 'react';

interface TeamBonusConfigButtonProps {
    visible: boolean;
    onClick: () => void;
    className?: string;
}

/** Öffnet PE-TeamBonus-Modal — nur sichtbar bei bonusMode === 'team'. */
export const TeamBonusConfigButton: React.FC<TeamBonusConfigButtonProps> = ({
    visible,
    onClick,
    className = '',
}) => {
    if (!visible) return null;

    return (
        <button
            type="button"
            onClick={onClick}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-amber-500/50 bg-amber-500/15 text-amber-600 dark:text-amber-300 text-[10px] font-black uppercase tracking-widest hover:bg-amber-500/25 hover:border-amber-400 transition-all ${className}`}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
            </svg>
            PE-TeamBonus
        </button>
    );
};

export default TeamBonusConfigButton;
